import { Spacing, Text, List } from "@ottatech/design";
import styled from "styled-components";

import { Headshot } from "components/Headshot";
import { ApplyModalJob } from "schema";

const PersonWrapper = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

const Centered = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin-left: 12px;
`;

interface IInternalApplicationSummary {
  company: ApplyModalJob.Company;
}

export const InternalApplicationSummary = ({
  company: { featuredRecruiter: recruiter, ...company },
  ...props
}: IInternalApplicationSummary): React.ReactElement => {
  const isOttaJob = company.name === "Otta";
  return (
    <Spacing>
      {!isOttaJob && (
        <Spacing>
          <Text bold align="center">
            {company.name} is accepting applications via Otta because we help
            candidates write great applications
          </Text>
          <List type="positive">
            <li>Companies prefer receiving applications through Otta</li>
            <li>
              We&apos;ll guide you to write a great application and stand out
            </li>
          </List>
        </Spacing>
      )}
      {recruiter && recruiter.profileImagePath && (
        <PersonWrapper {...props}>
          <Headshot
            image={recruiter.profileImagePath}
            alt={`${recruiter.firstName} headshot`}
          />
          <Centered>
            <Text>
              Your application will be sent to{" "}
              <Text as="span" bold>
                {recruiter.firstName}
              </Text>
              , {recruiter.currentTitle} at {company.name}
            </Text>
          </Centered>
        </PersonWrapper>
      )}
    </Spacing>
  );
};
